import { httpClient } from "./http-client";
import { NEW_API_ENDPOINTS } from "../../shared/constants/api";
import type {
  LoginRequest,
  ApiResponseTokenResponse,
  ApiResponseBoolean,
  VerifyPasswordCommand,
  SocialLoginRequest,
  SignupRequest,
  ApiResponseRefreshToken,
} from "../../shared/types/api";

export class AuthApiService {
  async verifyPassword(
    data: VerifyPasswordCommand,
  ): Promise<ApiResponseBoolean> {
    const response = await httpClient.post<ApiResponseBoolean>(
      NEW_API_ENDPOINTS.authenticationController.POST.verifyPassword,
      data,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "비밀번호 확인에 실패했습니다.",
      );
    }

    return response.data;
  }

  async socialLogin(
    data: SocialLoginRequest,
  ): Promise<ApiResponseTokenResponse> {
    const response = await httpClient.post<ApiResponseTokenResponse>(
      NEW_API_ENDPOINTS.authenticationController.POST.social,
      data,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "소셜 로그인에 실패했습니다.");
    }

    return response.data;
  }

  async signup(request: SignupRequest): Promise<ApiResponseBoolean> {
    const response = await httpClient.post<ApiResponseBoolean>(
      NEW_API_ENDPOINTS.authenticationController.POST.signup,
      request,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "회원가입에 실패했습니다.");
    }

    return response.data;
  }

  async reissue(refreshToken: string): Promise<ApiResponseRefreshToken> {
    const response = await httpClient.post<ApiResponseRefreshToken>(
      NEW_API_ENDPOINTS.authenticationController.POST.reissue,
      { refreshToken },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "토큰 재갱신에 실패했습니다.");
    }

    return response.data;
  }

  async login(request: LoginRequest): Promise<ApiResponseTokenResponse> {
    const response = await httpClient.post<ApiResponseTokenResponse>(
      NEW_API_ENDPOINTS.authenticationController.POST.login,
      request,
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "로그인에 실패했습니다.");
    }

    return response.data;
  }

  /** 워크스페이스 선택 → 그 회사 계정의 토큰 */
  async selectWorkspace(selectionToken: string, userId: number): Promise<ApiResponseTokenResponse> {
    const response = await httpClient.post<ApiResponseTokenResponse>(
      NEW_API_ENDPOINTS.authenticationController.POST.workspace,
      { selectionToken, userId },
    );

    if (response.data.errorCode) {
      throw new Error(response.data.errorMsg || "워크스페이스 선택에 실패했습니다.");
    }

    return response.data;
  }
}

export const authApiService = new AuthApiService();
